import React from 'react';

const minutes=(value:string)=>{const [h,m]=value.split(':').map(Number);return h*60+m;};
const bands=(start:string,end?:string|null)=>{
  const a=minutes(start),b=end?minutes(end):1440;
  if(!Number.isFinite(a)||!Number.isFinite(b))return [];
  return b<=a?[[a,1440]]:[[a,b]];
};
export default function DisponibilidadHorario({fecha,inicio,fin,ocupaciones,loading,error}: {
  fecha:string; inicio:string|null; fin:string|null; ocupaciones:{hora_inicio?:string|null;hora_fin?:string|null}[];
  loading:boolean; error:string|null;
}) {
  return <section className="cw-hour-timeline" aria-label="Disponibilidad del horario">
    <header><h3>Disponibilidad del espacio</h3><span>{fecha}</span></header>
    {loading?<p role="status">Consultando ocupaciones…</p>:error?<p role="alert">{error}</p>:<>
      <div className="cw-hour-track">{ocupaciones.flatMap((o,i)=>o.hora_inicio?bands(o.hora_inicio,o.hora_fin).map(([a,b],j)=><span key={`busy-${i}-${j}`} className="busy" style={{left:`${a/14.4}%`,width:`${(b-a)/14.4}%`}}/>):[])}{inicio&&fin&&bands(inicio,fin).map(([a,b],i)=><span key={`selected-${i}`} className="selected" style={{left:`${a/14.4}%`,width:`${(b-a)/14.4}%`}}/>)}</div>
      <div className="cw-hour-labels">{['00:00','06:00','12:00','18:00','24:00'].map(t=><span key={t}>{t}</span>)}</div>{inicio&&fin&&minutes(fin)<=minutes(inicio)&&<p>La salida es al día siguiente, a las {fin.slice(0,5)}.</p>}<p><i className="busy"/>Ocupado <i className="selected"/>Tu horario · La disponibilidad completa se valida al confirmar.</p>
    </>}
  </section>;
}
